import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

/**
 * Returns true when the user is in the treatment arm — i.e. the Search by Image
 * entry point should be shown.
 */
export const useSearchByImageExperiment = () =>
    useAmplitudeExperimentBase(AmplitudeExperiments.SearchByImage, AmplitudeVariants.SearchByImage.Treatment);
